import React from 'react';

const Vehicles = ()=>{
    return(
        <div>
            Vehicles Page
        </div>
    )
}

export default Vehicles;